import React from 'react';
import classNames from 'classnames';
import { LangSwitch } from '~/components';

interface MobileAccountLayoutProps {
    className?: string;
    showLangSwitch?: boolean;
    alignCenter?: boolean;
    children: React.ReactNode;
}

const MobileAccountLayout: React.FC<MobileAccountLayoutProps> = (props) => {
    const { className, showLangSwitch, alignCenter, children } = props;

    const renderLangSwitch = () => {
        return showLangSwitch && <LangSwitch className="lang-switch" />;
    };

    return (
        <div
            className={classNames('fx-mobile-account-layout', className, {
                'align-center': alignCenter
            })}
        >
            <div className="content-wrapper">
                <div className="content">
                    {children}
                    {alignCenter && (
                        <div className="mobile-account-layout-footer">{renderLangSwitch()}</div>
                    )}
                </div>
            </div>
            {!alignCenter && renderLangSwitch()}
        </div>
    );
};
export default MobileAccountLayout;
